module.exports = __webpack_public_path__ + "static/media/Background.f550c3bb.png";